import { createUseStyles } from 'react-jss';

export default createUseStyles({
  cardContainer: {
    width: 200,
    border: '1px solid rgba(0,0,0,0.5)',
    cursor:'pointer',
    borderRadius: 10,
    margin :'10px auto',
    zIndex: 1,
    padding: 10,
    fontWeight: 'bold',
    backgroundColor: 'white',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& .card-description': {
      fontSize: 12,
      fontWeight: '300',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginTop: 5
    }
  }
})